import { FrondEngine } from "@frond/engine";

interface Props {
  engine: FrondEngine;
  version: number;
}

/** Bottom-left zoom HUD: depth indicator, zoom %, and quick controls. */
export function ZoomHud({ engine }: Props) {
  const cam = engine.camera;
  const depth = cam.depth;
  const zoomPct = (cam.scale * Math.pow(2, depth)) / 100;

  const zoom = (f: number) => {
    const { w, h } = engine.renderer.size;
    cam.zoomAt(w / 2, h / 2, { x: w / 2, y: h / 2 }, f);
    engine.requestRender();
  };

  return (
    <div className="zoom-hud">
      <button className="hud-btn" onClick={() => zoom(1 / 1.5)} title="Zoom out (-)">
        −
      </button>
      <div className="zoom-readout" title="Zoom level (relative to the root canvas)">
        <div className="zoom-line1">{formatZoom(zoomPct)}</div>
        <div className="zoom-line2">{depth > 0 ? `depth ${depth} · 2^${depth}` : "top level"}</div>
      </div>
      <button className="hud-btn" onClick={() => zoom(1.5)} title="Zoom in (+)">
        +
      </button>
      <button className="hud-btn" onClick={() => engine.fitView()} title="Fit view">
        ⛶
      </button>
      <button className="hud-btn" onClick={() => engine.zoomToContent()} title="Zoom to content">
        🎯
      </button>
      <button
        className={`hud-btn ${engine.grid.enabled ? "active" : ""}`}
        onClick={() => engine.toggleGrid()}
        title={engine.grid.enabled ? "Hide grid" : "Show grid"}
      >
        #
      </button>
    </div>
  );
}

function formatZoom(z: number): string {
  if (z >= 100) return `${Math.round(z)}×`;
  if (z >= 1) return `${z.toFixed(1)}×`;
  if (z >= 0.01) return `${(z * 100).toFixed(0)}%`;
  return `10^${Math.round(Math.log10(z))}`;
}
